import { ref, computed } from '@vue/composition-api';

export function useHomeworkList() {
  const { ServiceFactory } = require('@/service/ServiceFactory');
  const instance = ServiceFactory.get('homework');

  const homeworkList = ref([]);

  /**
   * Fetch items from API
   * @param {string} token
   * */
  async function fetchHomeworkList(token: string) {
    try {
      const { data } = await instance.list(token);
      homeworkList.value = data;
    } catch (e) {
      throw e;
    }
  }

  return {
    homeworkList,
    fetchHomeworkList,
  };
}
